import { defineElement, html, TemplateElement } from '@webtides/element-js';
import style from './retailer-list.css';
import '../retailer-card/retailer-card';
export default class RetailerList extends TemplateElement {
    constructor() {
        super({ shadowRender: false, styles: [style] });
    }

    properties() {
        return {
            retailers: [],
            retailerCardDisplayOptions: {},
        };
    }

    provideProperties() {
        return {
            retailerCardDisplayOptions: this.retailerCardDisplayOptions,
        };
    }

    template() {
        return html`
            <div class="${this.retailers.length ? 'border border-grey-200' : ''}">
                ${this.retailers.map(retailer => {
                    return html` <retailer-card selected="false" .retailer="${retailer}"></retailer-card> `;
                })}
            </div>
        `;
    }
}

defineElement('retailer-list', RetailerList);
